import '@/styles/approval-panel.css'

export default {
  data() {
    return {
      approvalOpen: false,
      approvalPending: false,
      approvalPanelRegistrations: 0,
    }
  },
  provide() {
    return {
      approvalPanelController: {
        register: () => this.registerApprovalPanel(),
        unregister: () => this.unregisterApprovalPanel(),
        setPending: (pending) => this.setApprovalPending(pending),
        open: () => this.openApprovalPanel(),
      },
    }
  },
  computed: {
    hasApprovalPanel() {
      return Boolean(
        this.approvalPanelRegistrations ||
          this.$slots.topcontent ||
          this.$scopedSlots.topcontent,
      )
    },
    approvalPanelId() {
      return `approval-panel-${this._uid}`
    },
  },
  methods: {
    registerApprovalPanel() {
      this.approvalPanelRegistrations += 1
    },
    unregisterApprovalPanel() {
      this.approvalPanelRegistrations = Math.max(
        0,
        this.approvalPanelRegistrations - 1,
      )
      if (!this.approvalPanelRegistrations) {
        this.approvalOpen = false
        this.approvalPending = false
      }
    },
    setApprovalPending(pending) {
      const nextPending = Boolean(pending)
      const pendingChanged = nextPending !== this.approvalPending
      this.approvalPending = nextPending
      if (nextPending) {
        this.approvalOpen = true
      } else if (pendingChanged) {
        this.approvalOpen = false
      }
    },
    toggleApprovalPanel() {
      if (this.approvalOpen) {
        this.closeApprovalPanel()
      } else {
        this.openApprovalPanel()
      }
    },
    openApprovalPanel() {
      this.approvalOpen = true
      this.$nextTick(() => {
        this.$refs.approvalAside?.focus()
      })
    },
    closeApprovalPanel() {
      this.approvalOpen = false
    },
  },
}
